<template>
    <div>
        <div
                class="p-3 border-t hover:bg-blue-lighter cursor-pointer"
                v-on:click="click()"
                :class="{'bg-grey': !isAvailable,
                'bg-blue-lightest': isSelected,
                }"
                :style="padding"
        >
        <span
                :class="{'bg-grey': !isAvailable}"
        >
            <i
                    class="fa fa-fw"
                    :class="{
                        'fa-check-square-o': isSelected,
                        'fa-square-o': !isSelected,
                    }"
            ></i>
            {{ description }}
        </span>
        </div>
    </div>

</template>

<script>

    export default {

        props: ['item', 'search', 'depth'],

        data: function() {
            return {
                storage: storage,
            };
        },

        computed: {
            padding: function () {
                return 'padding-left:' + ((this.depth * 0.75) + 0.75) + 'rem';
            },
            description: function() {
                return this.item.translations.en;
                // TODO | highlight search
            },
            isSelected: function () {
                var id = this.item.id;
                var foo = this.storage.selected.filter(function (value) {
                    return value.id === id;
                });

                return foo.length === 1;
            },

            isAvailable: function() {
                var dimension = this.item.code_list;

                var bar = this.storage.disabledStates[dimension];
                if (!bar) {
                    return true;
                }

                var result = bar.find(element => {
                    return element === this.item.id;
                });

                return result === undefined;
            }
        },

        methods: {

            click: function () {
                if (this.isSelected) {
                    this.storage.deselectItem(this.item);
                } else {
                    this.storage.selectItem(this.item);
                }
            },

        }

    }

</script>